(function () {
  // ---------- Facebook Pixel AddToCart ----------
  // O evento product_added_to_cart da Shopify Web Pixels API nao dispara
  // fiavelmente para adds AJAX manuais. Disparamos aqui diretamente para
  // o pixel certo, conforme a variante adicionada.
  var PIXEL_BY_VARIANT = {
    '55313172693378': '1179551716421624', // Kyoslim
    '56695379034498': '1456726179540249'  // Gut Reset
  };

  function parseEuroPrice(str) {
    if (!str) return 0;
    return Number(String(str).replace(/[^\d,.]/g, '').replace(/\./g, '').replace(',', '.')) || 0;
  }

  function fireAddToCart(variantId, qty, totalValue) {
    var pixelId = PIXEL_BY_VARIANT[String(variantId)];
    if (!pixelId) return;
    var params = new URLSearchParams({
      id: pixelId,
      ev: 'AddToCart',
      rl: Date.now().toString()
    });
    params.append('cd[currency]', 'EUR');
    params.append('cd[value]', Number(totalValue || 0).toFixed(2));
    params.append('cd[content_ids]', JSON.stringify([String(variantId)]));
    params.append('cd[content_type]', 'product');
    params.append('cd[num_items]', String(qty));
    try {
      fetch('https://www.facebook.com/tr/?' + params.toString(), {
        method: 'GET',
        mode: 'no-cors',
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  function initSelector(root) {
    var cta = root.querySelector('[data-kps-cta]');
    var ctaText = root.querySelector('[data-kps-cta-text]');
    var ctaPrice = root.querySelector('[data-kps-cta-price]');
    var ctaSave = root.querySelector('[data-kps-cta-save]');
    var msg = root.querySelector('[data-kps-msg]');
    var pbTotal = root.querySelector('[data-kps-pricebox-total]');
    var pbCompare = root.querySelector('[data-kps-pricebox-compare]');
    var pbSave = root.querySelector('[data-kps-pricebox-save]');

    function selectedInput() {
      return root.querySelector('input[data-kps-input]:checked');
    }

    function syncCards() {
      root.querySelectorAll('[data-kps-card]').forEach(function (card) {
        var input = card.querySelector('input[data-kps-input]');
        card.classList.toggle('is-selected', !!input && input.checked);
      });
    }

    function updateCta() {
      var input = selectedInput();
      if (!input) return;
      ctaText.textContent = input.dataset.label || 'Adicionar ao carrinho';
      ctaPrice.textContent = input.dataset.price ? '· ' + input.dataset.price : '';
      ctaSave.textContent = input.dataset.save || '';

      // Atualizar bloco de preço destacado (per-bottle)
      if (pbTotal) pbTotal.textContent = input.dataset.per || input.dataset.price || '';
      if (pbCompare) pbCompare.textContent = input.dataset.perCompare || '';
      if (pbSave) pbSave.textContent = input.dataset.save || '';
    }

    root.addEventListener('change', function (e) {
      if (!e.target.matches('input[data-kps-input]')) return;
      syncCards();
      updateCta();
    });

    cta.addEventListener('click', function () {
      if (cta.classList.contains('is-loading')) return;
      var input = selectedInput();
      if (!input) {
        msg.textContent = 'Seleciona um pack primeiro.';
        return;
      }

      var body = {
        id: input.dataset.variant,
        quantity: parseInt(input.dataset.qty, 10) || 1
      };

      msg.textContent = '';
      cta.classList.add('is-loading');
      cta.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          if (res.ok) {
            // Dispara AddToCart no pixel certo antes de redirecionar.
            // keepalive garante que o request completa apos o navigate.
            try {
              fireAddToCart(body.id, body.quantity, parseEuroPrice(input.dataset.price));
            } catch (e) {}
            window.location.href = '/checkout';
            return;
          }
          return res.json().then(function (err) {
            throw new Error(err.description || 'Não foi possível adicionar ao carrinho.');
          });
        })
        .catch(function (err) {
          msg.textContent = err.message || 'Ocorreu um erro. Tenta novamente.';
          cta.classList.remove('is-loading');
          cta.disabled = false;
        });
    });

    syncCards();
    updateCta();
  }

  function init() {
    document.querySelectorAll('[data-kps]').forEach(initSelector);
  }

  // ---------- Badge Judge.me clicavel ----------
  // Quando o utilizador clica no badge "X reviews" do Judge.me no hero,
  // abre a tab "Avaliacoes" (tab-4) na seccao de tabs e faz scroll ate la.
  function setupJdgmBadgeClick() {
    document.addEventListener('click', function (e) {
      var badge = e.target.closest('.jdgm-prev-badge, .jdgm-preview-badge');
      if (!badge) return;
      // Ignora se ja for um link (Judge.me podera adicionar suporte nativo no futuro)
      if (e.target.closest('a')) return;
      e.preventDefault();

      // Scroll suave ate a seccao dedicada de reviews
      var section = document.querySelector('.kyoslim-reviews-section');
      if (!section) {
        // Fallback: abre a tab "Avaliacoes" e faz scroll
        var tabTrigger = document.querySelector('[data-tab-id="tab-4"], a[href="#tab-4"]');
        if (tabTrigger) tabTrigger.click();
        section = document.querySelector('[id*="tabbed_content"]');
      }
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      setupJdgmBadgeClick();
    });
  } else {
    init();
    setupJdgmBadgeClick();
  }
})();
